var React = require('react');

function Pen (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.352 4.002l-1.32 1.32-2.355-2.355 1.32-1.32c.65-.65 1.706-.65 2.355 0 .65.649.65 1.706 0 2.355zM4.28 14.075l-3.01.654.655-3.009 8.243-8.244 2.355 2.355-8.243 8.244zM14.862 1.138a2.388 2.388 0 0 0-3.373 0L1.341 11.286a.359.359 0 0 0-.097.178L.45 15.123a.361.361 0 0 0 .428.428l3.659-.795a.36.36 0 0 0 .178-.098L14.862 4.511c.93-.93.93-2.443 0-3.373z","fill":"currentColor"}));
}

Pen.defaultProps = {"width":"16","height":"16","fill":"none"};

module.exports = Pen;

Pen.default = Pen;
